(function () {
  const today = moment.utc().add(8, 'h').format('YYYY-MM-DD');

  // 取出本地資料
  let dataStr = localStorage.getItem('RentaTW-7anniversary');
  let data = null;

  // 轉換資料，如果資料不是今天的，忽略
  if (dataStr) {
    try {
      data = JSON.parse(dataStr);
    } catch (e) {
      data = null;
    }
    if (data.date !== today) {
      data = null;
    }
  }

  // 如果沒有資料，生成預設
  data = data || {
    date: today,
    click: 0,
  };

  updateGame();

  // 綁定點擊事件
  let clickTimer = 0;
  document.querySelector('#game_img').addEventListener('click', (e) => {
    if (clickTimer) {
      clearTimeout(clickTimer);
    }
    document.querySelector('#game_img .avatar').classList.add('down');
    clickTimer = setTimeout(() => {
      document.querySelector('#game_img .avatar').classList.remove('down');
    }, 100);
    data.click++;
    updateGame();
  });

  // 修改 UI
  function updateGame() {
    if (data.click) {
      document.querySelector('#game_times1').textContent = '1/1';
      document.querySelector('#game_times2').textContent = '1/1';
    }
    const counts = [1, 10, 201, 401, 601];
    // const counts = [1, 5, 10, 15, 20];
    const status = counts.reduce((prev, count, idx) => {
      return data.click >= count ? idx : prev;
    }, null);
    document.querySelector('#game_img').className = `img img${status}`;

    localStorage.setItem('RentaTW-7anniversary', JSON.stringify(data));
  }
})();
